import { useEffect, useState, useRef } from "react";

const formatTime = (secondsInput) => {
  const hours = Math.floor(secondsInput / 3600);
  const minutes = Math.floor((secondsInput % 3600) / 60);
  const seconds = secondsInput % 60;

  // Pad the values to ensure two digits
  const paddedHours = String(hours).padStart(2, '0');
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
};

const ProgressiveTickCircle = ({
  radius = 50,           // Radius of the circle
  tickLength = 10,       // Length of each tick mark
  totalTicks = 24,       // Total number of ticks (e.g., one every 15 degrees)
  tickDuration = 1000,   // Duration of each tick in milliseconds
  strokeWidth = 2.25,       // Width of the tick marks
  onComplete, // Callback when all ticks are drawn
  start = false,         // Trigger to start the animation
  stop = false,          // Trigger to stop the animation
  clear = false,         // Trigger to clear all ticks
  micIcon,               // Mic icon image source
}) => {
  const [totalTickCount, setTotalTickCount] = useState(0);
  const [currentTick, setCurrentTick] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);
  const loopCounter = useRef(1);
  const strokeColor = useRef("#cccccc");
  const centerX = radius + tickLength;
  const centerY = radius + tickLength;

  const calculateTick = (angleInDegrees) => {
    const angleInRadians = (angleInDegrees * Math.PI) / 180;
    const startX = centerX + radius * Math.cos(angleInRadians);
    const startY = centerY + radius * Math.sin(angleInRadians);
    const endX = centerX + (radius - tickLength) * Math.cos(angleInRadians);
    const endY = centerY + (radius - tickLength) * Math.sin(angleInRadians);
    return { startX, startY, endX, endY };
  };

  useEffect(() => {
    if (start) {
      setIsRunning(true);
    }
    if (stop) {
      setIsRunning(false);
      clearInterval(intervalRef.current);
      if (onComplete) {
        onComplete(true);
      }
    }
    if (clear) {
      setIsRunning(false);
      clearInterval(intervalRef.current);
      setCurrentTick(0);
      setTotalTickCount(0);
      strokeColor.current = "#cccccc";
      if (onComplete) {
        onComplete(true);
      }
    }
  }, [start, stop, clear, onComplete]);

  useEffect(() => {
    if (isRunning && currentTick <= totalTicks) {
      intervalRef.current = setInterval(() => {
        setCurrentTick((prev) => {
          setTotalTickCount((prevCount) => prevCount + 1);
          const nextTick = prev + 1;
          if (nextTick > totalTicks) {
            loopCounter.current = loopCounter.current + 1;
            clearInterval(intervalRef.current);
            // setIsRunning(false);
            setCurrentTick(0);
            if (strokeColor.current === "#cccccc") {
              strokeColor.current = "#6b9797";
            }
            else {
              strokeColor.current = "#cccccc";
            }
          }
          return nextTick;
        });
      }, tickDuration);
    }
    return () => clearInterval(intervalRef.current);
  }, [isRunning, currentTick, totalTicks, tickDuration]);

  const ticks = Array.from({ length: currentTick }, (_, index) => {
    const angle = (360 / totalTicks) * index;
    return calculateTick(angle);
  });

  return (
    <div
      style={{
        position: 'relative',
        width: `${(radius + tickLength) * 2}px`,
        height: `${(radius + tickLength) * 2}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Mic Icon */}
      {/* <img
        src={micIcon}
        alt="Mic Icon"
        style={{
          position: 'absolute',
          width: `${radius}px`, // Ensure the image size is proportional to the circle
          height: `${radius}px`, // Maintain aspect ratio
          objectFit: 'contain', // Ensure the image fits within the bounds
        }}
      /> */}
      {/* SVG Circle */}
      <svg
        style={{ position: 'absolute' }}
        width={(radius + tickLength) * 2}
        height={(radius + tickLength) * 2}
        viewBox={`0 0 ${(radius + tickLength) * 2} ${(radius + tickLength) * 2}`}
      >
        {/* Background Circle */}
        <circle
          cx={centerX}
          cy={centerY}
          r={radius}
          stroke="#f8f8f8f8"
          // strokeWidth={strokeWidth}
          fill="#f8f8f8f8"
        />
        {/* Progressive Tick Marks */}
        {ticks.map((tick, index) => (
          <line
            key={index}
            x1={tick.startX}
            y1={tick.startY}
            x2={tick.endX}
            y2={tick.endY}
            stroke={strokeColor.current}
            strokeWidth={strokeWidth}
          />
        ))}
      </svg>
      <img
        src={micIcon}
        alt="Mic Icon"
        style={{
          position: 'absolute',
          width: `${radius}px`, // Ensure the image size is proportional to the circle
          height: `${radius}px`, // Maintain aspect ratio
          objectFit: 'contain', // Ensure the image fits within the bounds
        }}
      />

      <div style={{ position: 'absolute', bottom: "10px", left: "100px" }}>{formatTime(totalTickCount)}</div>
    </div>
  );
};


export default ProgressiveTickCircle;
